import { render, staticRenderFns } from "./ResizableAside.vue?vue&type=template&id=52d967b0&scoped=true"
import script from "./ResizableAside.vue?vue&type=script&lang=js"
export * from "./ResizableAside.vue?vue&type=script&lang=js"
import style0 from "./ResizableAside.vue?vue&type=style&index=0&id=52d967b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d967b0",
  null
  
)

export default component.exports